import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { useTheme } from '@mui/material';

export default function FilteredSelect({
    options,
    selectedOption,
    handleOptionChange,
    label,
}: {
    options: string[];
    selectedOption: string;
    handleOptionChange: (option: string) => void;
    label: string;
}) {
    const theme = useTheme();
    const [inputValue, setInputValue] = React.useState('');

    const allowTyping = options.length > 5;

    const handleInputChange = (
        event: React.SyntheticEvent<Element, Event>,
        value: string,
    ) => {
        setInputValue(value);
    };

    React.useEffect(() => {
        setInputValue(selectedOption);
    }, [selectedOption]);

    return (
        <div>
            <Autocomplete
                className={'rounded-full'}
                disablePortal
                id={'combo-box-demo'}
                options={options}
                sx={{
                    '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        '& fieldset': {
                            borderColor: theme.palette.border.light,
                        },
                        '&:hover fieldset': {
                            borderColor: theme.palette.border.main,
                        },
                        '&.Mui-focused fieldset': {
                            borderWidth: '1px',
                            borderColor: theme.palette.border.main,
                        },
                    },
                    '& .Mui-focused': {
                        color: theme.palette.primary.light,
                    },
                    '& .MuiSvgIcon-root': {
                        color: theme.palette.border.main,
                    },
                    '& label.Mui-focused': {
                        color: 'black',
                        opacity: 0.8,
                    },
                }}
                value={selectedOption}
                onChange={(
                    event: React.SyntheticEvent,
                    value: string | null,
                ) => {
                    handleOptionChange(value ?? '');
                }}
                freeSolo={allowTyping}
                onInputChange={handleInputChange}
                inputValue={inputValue}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={label}
                        InputProps={{
                            ...params.InputProps,
                            readOnly: !allowTyping,
                            style: { color: 'black' },
                        }}
                    />
                )}
                renderOption={(props, option, state) => (
                    <li
                        {...props}
                        style={{
                            backgroundColor: state.selected ? theme.palette.primary.light : 'transparent', 
                            color: 'black', 
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = state.selected
                                ? theme.palette.primary.light : 
                                theme.palette.action.hover;
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = state.selected
                                ? theme.palette.primary.light
                                : 'transparent';
                        }}
                    >
                        {option}
                    </li>
                )}
            />
        </div>
    );
}
